import React, { FC, ChangeEvent } from "react";

import { FormSizes } from "~/constants/buttonAndForm";

import { TextField, Label } from "~/ui";

type FieldType = "text" | "email" | "password" | "search" | "tel" | "url";

type PropsType = {
  labelText: string;
  type: FieldType;
  name: string;
  value?: string;
  defaultValue?: string;
  autoComplete?: string;
  placeholder?: string;
  required?: boolean;
  disabled?: boolean;
  textFieldClassName?: string;
  className?: string;
  size?: keyof typeof FormSizes;
  tooltipText?: string;
  onChange?: (e: ChangeEvent<HTMLInputElement>) => void;
};

export const LabelWithTextField: FC<PropsType> = ({
  labelText,
  type = "text",
  name,
  value,
  defaultValue,
  autoComplete = "",
  placeholder = "",
  required = false,
  disabled = false,
  textFieldClassName = "",
  className = "",
  onChange,
  size = "sm",
  tooltipText,
}: PropsType) => {
  return (
    <div className={className}>
      <Label
        htmlFor={name}
        labelText={labelText}
        required={required}
        tooltipText={tooltipText}
        className="block"
      />
      <TextField
        type={type}
        name={name}
        value={value}
        defaultValue={defaultValue}
        autoComplete={autoComplete}
        placeholder={placeholder}
        required={required}
        disabled={disabled}
        onChange={onChange}
        size={size}
        className={`mt-1.5 ${textFieldClassName}`}
      />
    </div>
  );
};
